import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-logged-user-info',
  templateUrl: './logged-user-info.component.html',
  styleUrls: ['./logged-user-info.component.scss']
})
export class LoggedUserInfoComponent {
  @Output() onSignOut = new EventEmitter<any>();
  @Input() userName = ''
  @Input() showName = false;

  signOut(): void {
    this.onSignOut.emit(false);
  }
}
